import { Component, Input } from '@angular/core';
import { NotificationService, TranslationService } from 'src/app/shared';
import { UserDto } from '../shared/dto/user.dto';
import { UserService } from '../shared/user.service';

@Component({
  selector: 'wl-user-password-change',
  standalone: false,
  templateUrl: './user-password-change.component.html',
  styleUrl: './user-password-change.component.less',
})
export class UserPasswordChangeComponent {
  public show = false;
  public required = false;
  public isPasswordValid = false;
  public password1: string;
  public password2: string;
  public isSaving = false;
  public passwordIssues: string[] = [];
  public allowClose = false;

  @Input()
  get showRequired() {
    return this.show;
  }
  set showRequired(value: boolean) {
    this.show = value;
    this.required = value;
  }
  @Input()
  get showOptional() {
    return this.show;
  }
  set showOptional(value: boolean) {
    this.show = value;
    this.required = !value;
  }

  @Input('userNum') userNum: number;

  public constructor(
    private _notificationService: NotificationService,
    private _translationService: TranslationService,
    private _userService: UserService
  ) {}

  validatePassword() {
    this.passwordIssues = [];
    if (this.password1?.length > 0) {
      const validRegEx: RegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d]).{8,}$/;
      this.isPasswordValid = validRegEx.test(this.password1);
    }

    if (!this.isPasswordValid) {
      this.passwordIssues.push(this._translationService.getInstant('shared.container.top-nav.password-reset.password-invalid'));
    }

    if (this.password2?.length > 0 && this.password2 != this.password1) {
      this.passwordIssues.push(this._translationService.getInstant('shared.container.top-nav.password-reset.password-mismatch'));
    }

    if (this.isPasswordValid && this.password2 == this.password1) {
      this.passwordIssues = [];
    }
  }

  public save() {
    // because of UI updating issues, we need to double-check for valid passwords.
    this.validatePassword();
    if (this.passwordIssues.length > 0) {
      return;
    }

    this.isSaving = true;
    this._userService.get(this.userNum).then(
      (user: UserDto) => {
        if (user.UserNum != null && user.UserNum > 0) {
          user.Pass = this.password1;

          this._userService
            .upsert(user)
            .then((result) => {
              if (result != null && result.PsfyIdpId != '') {
                this._notificationService.success(this._translationService.getInstant('shared.container.top-nav.password-reset.success'));
                this.show = false;
                this.showRequired = false;
              }
            })
            .catch((error) => {
              this.allowClose = true;
              this._notificationService.httpError(error);
            })
            .finally(() => {
              this.isSaving = false;
            });
        }
      },
      (error) => {
        this._notificationService.httpError(error);
        this.isSaving = false;
      }
    );
  }
}
